import { useContext } from "@wordpress/element";
import { RulesContext } from "../context/RulesContext";

export const useRulesContext = () => {
    const context = useContext(RulesContext);

    if (!context) {
        throw new Error(
            "RulesContext must be used within a RulesContextProvider. " +
                "Make sure your component is wrapped with <RulesContextProvider>."
        );
    }

    return context;
};
